import React from "react";
import Modal from "@mui/material/Modal";

const CreateModal = ({ open, handleClose, customCSS, children }) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <div className="edit-modal-payment" style={{ ...customCSS }}>
        {children}
      </div>
    </Modal>
  );
};

export default CreateModal;
